import React, { useEffect, useState } from 'react';
import Reveal from './Reveal';
import { ChevronLeftIcon, ChevronRightIcon, PrinterIcon } from './Icons';
import AppLink from './AppLink';

export default function SolutionCarousel({ stats, slides }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setIndex((current) => (current + 1) % slides.length);
    }, 5200);

    return () => window.clearInterval(id);
  }, [slides.length]);

  const slide = slides[index];

  const goTo = (nextIndex) => {
    setIndex((nextIndex + slides.length) % slides.length);
  };

  return (
    <section className="solutions-section">
      <div className="solutions-decor solutions-decor--one" />
      <div className="solutions-decor solutions-decor--two" />
      <Reveal className="container solutions-shell" variant="fade-scale" duration={950} threshold={0.14} scaleFrom={0.95}>
        <SectionIntro />
        <div className="solutions-grid">
          <div className="solutions-stats">
            {stats.map((stat, statIndex) => (
              <Reveal
                key={stat.label}
                className="stat-item"
                variant="fade-up-scale"
                duration={720}
                threshold={0.2}
                distance={38}
                scaleFrom={0.92}
                delay={statIndex * 90}
              >
                <h3 className="stat-value">
                  {stat.icon === 'printer' ? (
                    <PrinterIcon className="stat-value-icon" style={{ color: slide.accent }} />
                  ) : (
                    <span style={{ color: slide.accent }}>{stat.value}</span>
                  )}
                </h3>
                <p className="stat-label">{stat.label}</p>
              </Reveal>
            ))}
          </div>

          <Reveal className="solutions-carousel" variant="fade-scale" duration={900} threshold={0.12} scaleFrom={0.95}>
            <div className="carousel-frame">
              <div className="carousel-media" key={slide.title}>
                <img
                  src={slide.image}
                  alt={slide.title}
                  style={{
                    objectFit: slide.mediaFit || 'cover',
                    objectPosition: slide.mediaPosition || 'center center'
                  }}
                />
                <div className="carousel-overlay" style={{ background: slide.overlay }} />
                <div className="carousel-copy">
                  <h3>{slide.title}</h3>
                  <p>{slide.description}</p>
                </div>
              </div>

              <div className="carousel-nav" aria-label="Selecionar solução">
                <button type="button" className="carousel-arrow" onClick={() => goTo(index - 1)} aria-label="Anterior">
                  <ChevronLeftIcon className="icon icon--small" />
                </button>

                <div className="carousel-dots">
                  {slides.map((item, itemIndex) => (
                    <button
                      key={item.title}
                      type="button"
                      className={`carousel-dot ${itemIndex === index ? 'is-active' : ''}`}
                      style={{ backgroundColor: itemIndex === index ? slide.accent : undefined }}
                      onClick={() => goTo(itemIndex)}
                      aria-label={`Ver ${item.title}`}
                    />
                  ))}
                </div>

                <button type="button" className="carousel-arrow" onClick={() => goTo(index + 1)} aria-label="Próximo">
                  <ChevronRightIcon className="icon icon--small" />
                </button>
              </div>
            </div>
          </Reveal>
        </div>
      </Reveal>
    </section>
  );
}

function SectionIntro() {
  return (
    <div className="solutions-heading">
      <Reveal as="h2" className="section-title" variant="fade-up" duration={760} threshold={0.2} distance={30}>
        Nossas Soluções
      </Reveal>
      <Reveal as="p" className="section-subtitle" variant="fade-up" duration={820} threshold={0.2} distance={34} delay={110}>
        Conheça todas as funcionalidades do EtiquetandoApp
      </Reveal>
    </div>
  );
}
